module.exports = __webpack_public_path__ + "media/images/plans/wedding_reception/ex-royal-79ca25a7731b4f83e5362ab1d8675253.png";